import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataStockByDate(params) {
    return client.get("tunnel/api/pos/inventory/stock_by_date", {
        params: params,
    });
}

function getDataStock(params) {
    return client.get("tunnel/api/pos/inventory/stock", {
        params: params
    });
}

function getDataStockSummarySerial() {
    return client.get("tunnel/api/pos/inventory/stock-serial-summary");
}

function getDetailStock(val) {
    return client.get("tunnel/api/pos/inventory/stock_detail", {
        params: val
    });
}

function getDataStockSerial(params) {
    return client.get("tunnel/api/pos/inventory/data-serial", {
        params: params,
    });
}

function convertSerialStock(params) {
  return client.post("tunnel/api/pos/inventory/convert_serial_stock", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataStockSerialDigital(params) {
    return client.get("tunnel/api/pos/inventory/data-serial-digital", {
        params: params,
    });
}

function getDataSerialDigitalSummary(params) {
    return client.get("tunnel/api/pos/inventory/serial-digital-summary", {
        params: params,
    });
}

function getDataSerialDigitalStoreSummary(params) {
    return client.get("tunnel/api/pos/inventory/serial-digital-store-summary", {
        params: params,
    });
}

export default {
    getDataStockByDate,
    getDataStock,
    getDataStockSummarySerial,
    getDetailStock,
    getDataStockSerial,
    convertSerialStock,
    getDataStockSerialDigital,
    getDataSerialDigitalSummary,
    getDataSerialDigitalStoreSummary
};
